module.exports = __webpack_public_path__ + "static/frevvo-8576adbdfec7848a5253bffb2bb4b612.png";